import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";

export const EventSummary = {
  h2: {
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 10,
  },
  containerWithClick: {
    cursor: "pointer",
  },
};

const icon = {
  color: greys.blueGrey,
  width: 18,
  height: 18,
  marginLeft: 0,
  marginRight: 12,
  flexShrink: 0,
};

export const EventSummaryRow = {
  icon,
  green: colors.green.darker,
  slate: greys.slate,
  container: {
    display: "flex",
    alignItems: "center",
    fontWeight: 400,
    padding: "5px 0",
  } as CSSProperties,
  iconDisabled: {
    ...icon,
    color: greys.blueGrey,
    flexShrink: 0,
  },
  iconProminent: {
    ...icon,
    color: colors.green.darker,
    flexShrink: 0,
  },
  iconWarning: {
    ...icon,
    color: colors.peach.darker,
    flexShrink: 0,
  },
  link: {
    color: colors.blueCool.standard,
    fontSize: 14,
    lineHeight: "18px",
  } as CSSProperties,
  text: {
    fontSize: 13,
    lineHeight: "14px",
    color: greys.slate,
    fontWeight: "normal",
    fontFamily: fontFamilySans,
  } as CSSProperties,
  textDisabled: {
    fontSize: 13,
    lineHeight: "18px",
    color: greys.blueGrey,
    fontWeight: 600,
  },
  textProminent: {
    fontSize: 13,
    lineHeight: "18px",
    color: colors.green.darker,
    fontWeight: 600,
  },
  textWarning: {
    fontSize: 13,
    lineHeight: "18px",
    color: colors.peach.darker,
    fontWeight: 600,
  },
  textEmphasized: {
    fontSize: 14,
    lineHeight: "21px",
    color: greys.standard,
  },
  textLessEmphasized: {
    fontSize: 13,
    lineHeight: "18px",
    color: greys.darkestGrey,
  },
};
